import { render, staticRenderFns } from "./bizcompTitleDc.vue?vue&type=template&id=75fd1d0d"
import script from "./bizcompTitleDc.vue?vue&type=script&lang=js"
export * from "./bizcompTitleDc.vue?vue&type=script&lang=js"
import style0 from "./bizcompTitleDc.vue?vue&type=style&index=0&id=75fd1d0d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports